import { Check, Minus } from 'lucide-react'
import './LandingPricing.css'

interface Props {
  onStart: () => void
}

export function LandingPricing({ onStart }: Props) {
  return (
    <section id="preise" className="landing-pricing">
      <div className="lp-inner">
        <div className="lp-header">
          <h2 className="lp-title">Einfache, transparente Preise</h2>
          <p className="lp-subtitle">Einmalig bezahlen — kein Abo, kein Account</p>
        </div>

        <div className="lp-cards">
          {/* ── Free ── */}
          <div className="lp-card">
            <div className="lp-tier-label">Kostenlos</div>
            <div className="lp-price-row">
              <span className="lp-amount">0 €</span>
            </div>
            <p className="lp-desc">Zum Ausprobieren</p>

            <ul className="lp-features">
              {[
                { t: 'PDF herunterladen (mit Wasserzeichen)', ok: true },
                { t: 'Bis zu 50 Nachrichten',       ok: true },
                { t: 'Anpassungsoptionen testen',   ok: true },
                { t: 'Unbegrenzte Nachrichten',      ok: false },
                { t: 'Kein Wasserzeichen',           ok: false },
                { t: 'Alle Medien im PDF',           ok: false },
              ].map(({ t, ok }, i) => (
                <li key={i} className={`lp-feature ${ok ? 'ok' : 'no'}`}>
                  {ok
                    ? <Check size={16} className="lp-check-icon" />
                    : <Minus size={16} className="lp-minus-icon" />
                  }
                  {t}
                </li>
              ))}
            </ul>

            <button className="lp-btn lp-btn-free" onClick={onStart}>
              Gratis testen
            </button>
          </div>

          {/* ── Premium ── */}
          <div className="lp-card lp-card-premium">
            <div className="lp-badge">Empfohlen</div>
            <div className="lp-tier-label">Premium</div>
            <div className="lp-price-row">
              <span className="lp-amount">4,99 €</span>
              <span className="lp-period">einmalig</span>
            </div>
            <p className="lp-desc">Vollständiges PDF · Für die Ewigkeit</p>

            <ul className="lp-features">
              {[
                'Live-Vorschau im Browser',
                'Unbegrenzt viele Nachrichten',
                'Alle Anpassungsoptionen',
                'Vollständiges PDF',
                'Kein Wasserzeichen',
                'Alle Medien im PDF',
              ].map((t, i) => (
                <li key={i} className="lp-feature ok">
                  <Check size={16} className="lp-check-icon" />
                  {t}
                </li>
              ))}
            </ul>

            <button className="lp-btn lp-btn-premium" onClick={onStart}>
              Jetzt PDF erstellen
            </button>
            <p className="lp-note">30 Tage Download-Link · Stripe-Zahlung</p>
          </div>
        </div>
      </div>
    </section>
  )
}
